export default __webpack_public_path__ + "static/media/bubble.0d76eeac.svg";